<div class="copilot" *ngIf="this.contentVisible">

  <!-- DevExtreme scroll view (DXScrollView) instead of the native browser scrollbar (owner request). The
       whole questionnaire + solutions column scrolls inside it; [useNative]="false" forces the DX scrollbar. -->
  <dx-scroll-view height="100%" [showScrollbar]="'always'" [useNative]="false">
  <div class="copilot-scroll-content" #scrollContent>

  <div class="copilot-header">
    <!-- CR-20260831-004 round 3: .param-changed = the active tab is not the tab of the LAST run
         ("user is looking not at the tab he ran previously") — the selected segment goes yellow. -->
    <dx-button-group
      [class.param-changed]="this.activeTabNotLastRun"
      [items]="this.tabItems"
      keyExpr="id"
      selectionMode="single"
      stylingMode="contained"
      [selectedItemKeys]="[this.activeTab]"
      (onItemClick)="this.onTabClick($event)"
    ></dx-button-group>
    <dx-button icon="refresh" hint="New Conversation"
               [ngClass]="this.getCopilotRefreshCss() | etsNgClassAsync:this"
               (onClick)="this.onNewConversation()"></dx-button>
  </div>

  <!-- Questionnaires: all three stay alive (form state survives tab switches); only the active one is
       shown. After a tab is Run it COLLAPSES: the form is hidden (NOT destroyed — state is preserved) and
       a clickable input summary replaces it. Clicking the summary re-expands the form. -->
  <!-- THE SELECT COPILOT (CR-20260804-001, the two-copilots reversal - ruling AF): the literal
       OPG Co-Pilot, embedded whole. It owns its questionnaire, Run flow, results, breadcrumb
       collapse and reset; the host run-bar below is therefore hidden on this tab. Previews land
       on the Hedge Matrix through the facade. -->
  <div class="questionnaire select-copilot-pane" [class.ets-hidden]="this.activeTab !== 'select'">
    <ets-opg-copilot [root]="this.selectFacade"
                     [showRefreshButton]="false"
                     previewModel="pick"
                     (widthModeChange)="this.onSelectWidthMode($event)"
                     (staleChange)="this.onEmbeddedStale($event)"
                     (gridStaleChange)="this.onEmbeddedGridStale($event)"
                     (runFired)="this.onEmbeddedRunFired()"></ets-opg-copilot>
  </div>
  <div class="questionnaire" [class.ets-hidden]="this.activeTab !== 'adjust'">
    <ets-hg-available-adjustments [ownerId]="portfolioOwnerId" [portfolioId]="portfolioId" [ctx]="ctx" [availability]="adjustmentAvailability"
      [targetItemId]="availableTargetItemId" [targetRequest]="additionalTargetRequest" [visible]="popupVisible && activeTab === 'adjust'"
      (expandedChange)="onAdditionalExpanded($event)" (previewActiveChange)="onAdditionalPreview($event)"
      (matrixMutationChange)="onAdditionalMatrixMutation($event)">
    </ets-hg-available-adjustments>
    <div [class.ets-hidden]="additionalAdjustExpanded">
    <ets-hg-copilot-adjust-tab [class.ets-hidden]="this.collapsed.adjust" [bookDates]="this.adjustDates" [targetInstrument]="this.targetInstrument" [strikeExpiration]="this.strikeExpiration" [changedKeys]="this.adjustParamChanges" [defaultQty]="this.defaultQty" (stateChange)="this.onAdjustState($event)"></ets-hg-copilot-adjust-tab>
    <!-- Manual collapse back to the input summary (no re-run) — the Select/OPG "Collapse
         Settings" affordance mirrored (owner 2026-08-04); shown only once this tab has a
         completed run, exactly the OPG gate. -->
    <div class="collapse-hint-row" *ngIf="!this.collapsed.adjust && this.hasCompletedAdjustRun">
      <span class="collapse-hint" data-element="btn-collapse-adjust"
            (click)="this.onCollapseAdjustRequested()">Collapse Settings</span>
    </div>
    <ets-hg-copilot-input-summary *ngIf="this.collapsed.adjust" [tabKind]="'adjust'" [inputs]="this.adjustInputs" [changedKeys]="this.adjustParamChanges" (expand)="this.expandTab('adjust')"></ets-hg-copilot-input-summary>
    </div>
  </div>
  <div class="questionnaire" [class.ets-hidden]="this.activeTab !== 'close'">
    <ets-hg-copilot-close-tab [class.ets-hidden]="this.collapsed.close"
      [bookDates]="this.bookDates"
      [bookHedges]="this.bookHedges"
      [changedKeys]="this.closeParamChanges"
      (stateChange)="this.onCloseState($event)"
    ></ets-hg-copilot-close-tab>
    <ets-hg-copilot-input-summary *ngIf="this.collapsed.close" [tabKind]="'close'" [inputs]="this.closeInputs" [bookHedges]="this.bookHedges" [changedKeys]="this.closeParamChanges" (expand)="this.expandTab('close')"></ets-hg-copilot-input-summary>
  </div>

  <div class="run-bar" *ngIf="this.activeTab !== 'select' && !(activeTab === 'adjust' && additionalAdjustExpanded)">
    <dx-button text="Ask ORION" type="default" [disabled]="!this.canRun" (onClick)="this.onRun()" width="100%"></dx-button>
  </div>

  <div class="notice elsewhere" *ngIf="this.runInProgressElsewhere && this.activeTab !== 'select'">
    An ORION Run is in Progress Elsewhere — Please Wait For it to Finish.
  </div>

  <ng-container *ngIf="!(activeTab === 'adjust' && additionalAdjustExpanded)">
  <ng-container *ngIf="this.activeRun as run">

    <div class="run-status pending" *ngIf="run.outcome === 'pending'">
      <dx-load-indicator [height]="18" [width]="18"></dx-load-indicator>
      <span class="msg">Running ORION… This Can Take a Couple of Minutes.</span>
      <!-- CR-20260910-001 milestone 2: NO CANCEL ON A CLOSE. A close ends by completing, by its
           deadline, or by being superseded — pressing Apply again replaces the running one. The
           backend has no cancel command for it at all, so a button here would be a control with
           nothing behind it. Adjust keeps its own cancel, which is a different engine. -->
      <dx-button text="Cancel" *ngIf="run.tabKind !== 'close'" (onClick)="this.onCancel()"></dx-button>
    </div>

    <!-- Empty = a valid "no suggestions" run (settings stay collapsed; dedicated component below).
         The engine states WHY it had nothing, and that reason rides on failureDetail — pass it in.
         Without it the box printed a fixed sentence and the diagnosis was only in the log. -->
    <ets-hg-copilot-empty-result *ngIf="run.outcome === 'empty'"
                                 [reason]="run.failureDetail"></ets-hg-copilot-empty-result>

    <!-- terminalFailed / preSendBlocked are surfaced as an error TOAST + the form auto-expands to fix
         (settleCollapse) — so no inline error panel here. -->

    <div class="run-status cancelled" *ngIf="run.outcome === 'cancelled'">
      Run Cancelled.
    </div>

  </ng-container>
  </ng-container>

  <!-- THE RUN-NOTES BOX IS GONE FROM THE GUI (owner, 2026-08-24). What stood here was the amber
       "notice level-notes" block: the engine's own sentences about lanes it dropped, rankings it
       lost and duplicate packages it withheld. The owner does not want those warnings and
       explanations on the panel.
       REMOVED FROM THE VIEW ONLY. The engine still writes every one of them - they ride the wire on
       CoPilotSolutionsReadyDto.notes and are logged backend-side to shell.trace.txt, which stays
       the place to read them. Nothing was changed behind the wire, so restoring the box is a
       template change and nothing more. -->

  <div class="solutions" *ngIf="this.activeSolutions.length > 0" [class.ets-hidden]="activeTab === 'adjust' && additionalAdjustExpanded">

    <!-- THE RESULTS TOOLBAR (owner screencast, CR-20260824-003). What stood here was the cost
         filter's checkbox ("Hide packages that cost more than they bring"); the owner removed it
         from the GUI and asked for sort controls in its place. The filter's CODE is deliberately
         still in the component, dormant and defaulted off - see resultFilters there.
         No tab guard any more (the checkbox was Adjust-only): sorting is offered wherever the host
         renders results. That is Adjust and Close - the Select tab's answers are rendered by the
         embedded OPG Co-Pilot, which owns its own list.
         Right-aligned, per the owner: the row reads as a tool, not as a heading. -->
    <div class="results-toolbar">
      <span class="sort-label">Sort by:</span>

      <!-- RISK. Visible always, CLICKABLE only when the result set holds more than one band -
           "that option should be visible but blocked, non-functional" (owner). A single-level
           Adjust run and every Close list carry no band at all, so there it is inert by design,
           and the title says why rather than leaving the trader to guess.
           ⚠ The <i> is rendered UNCONDITIONALLY and carries its glyph through [ngClass] - a null
           class paints nothing while the element still holds its width, so the row does not jog
           sideways as a key cycles through 'none'. An *ngIf here would remove the box and undo
           that. Whether an arrow is due at all is sortArrowClass's decision, not the template's. -->
      <span class="sort-key"
            [class.disabled]="!this.riskSortAvailable"
            [class.active]="this.riskSortAvailable && this.sortKeys.risk !== 'none'"
            [title]="this.riskSortAvailable
                       ? 'Group by Risk: Aggressive, Moderate, Low'
                       : 'Available When a Run Uses Max Risk: All'"
            data-element="sort-key-risk"
            (click)="this.onSortKeyClick('risk')">Risk<i class="arrow"
              [ngClass]="this.sortArrowClass('risk')"></i></span>

      <span class="sort-key"
            [class.active]="this.sortKeys.price !== 'none'"
            title="Order by Price: Best to Worst"
            data-element="sort-key-price"
            (click)="this.onSortKeyClick('price')">Price<i class="arrow"
              [ngClass]="this.sortArrowClass('price')"></i></span>
    </div>

    <!-- NEVER A SILENT CULL (owner, 2026-08-07). Each filter carries its own count above, so the
         per-reason breakdown that used to live here is gone. What CANNOT go is this box: when the
         filters hide everything the results area is empty, and "you hid them all" then looks
         exactly like "the engine found nothing" - which is a different fact, has a different fix,
         and renders the SAME empty box one level up (outcome 'empty'). The heading is what tells
         them apart, so it must never be allowed to fall back to "No suggestions" here. -->
    <ets-hg-copilot-empty-result *ngIf="this.allSolutionsHidden"
                                 heading="No Packages Match Your Filter"
                                 [reason]="this.allHiddenMessage"></ets-hg-copilot-empty-result>

    <!-- The results are here, the PRICES are not (the engine never prices). The list holds the
         engine's order until every leg of every package has a mid, then sorts once, under the keys
         the Sort by control above is showing. Said out loud because a list that is about to reorder
         and a list that is final look identical, and the trader would otherwise start reading a
         card that is going to move.
         The text says "will sort", NOT "will sort by price", since CR-20260824-003: the order is
         whatever that control currently says, which is not always price. A notice naming one key
         while the list settles under another is a claim the panel cannot keep. -->
    <div class="notice pricing-settling" *ngIf="this.isSettlingPrices">
      <span class="spinner"></span>
      Pricing {{ this.activeSolutions.length }} Packages - the List Will Sort Once Every Leg
      Has a Quote.
    </div>

    <!-- Individual per-hedge cards. While the aggregate Close-All card is expanded they collapse to the
         single summary line below (same collapse-to-summary pattern as the questionnaire/settings).
         The [class.ets-hidden] binding below hid a too-expensive card rather than destroying it:
         destroying it would drop its quote subscriptions and freeze the very price the filter
         judged by. ⚠ Since CR-20260824-003 that filter is dormant and isHiddenSolution() answers
         false for every card, so nothing is hidden here today — the binding is kept because the
         filter's code is (owner: "don't delete it from the code yet"). -->
    <ng-container *ngIf="!this.individualsCollapsed">
      <ets-hg-copilot-solution-card
        *ngFor="let sol of this.activeSolutions"
        [class.ets-hidden]="this.isHiddenSolution(sol)"
        [solution]="sol"
        [ctx]="this.ctx"
        [heldAtRun]="this.heldAtRun"
        [aggregateLocked]="this.activeTab === 'close' && this.closeAllState.previewed"
        (previewToggle)="this.onPreviewToggle($event)"
        (applyToggle)="this.onApplyToggle($event)"
        (openTransactions)="this.onOpenTransactions($event)"
      ></ets-hg-copilot-solution-card>
    </ng-container>

    <!-- Collapsed-individuals summary: one line reading "{N} individual items" (click to re-show them). -->
    <div class="individual-items-summary" *ngIf="this.individualsCollapsed" (click)="this.onCloseAllExpandedChange(false)">
      {{ this.activeSolutions.length }} Individual Items
    </div>

    <!-- Aggregate "Close All / Chosen" card: close tab only, and only when there is more than one hedge to
         act on at once (CR-20260619-001, Close-All increment). -->
    <ets-hg-copilot-close-all-card
      *ngIf="this.activeTab === 'close' && this.activeSolutions.length > 1"
      [solutions]="this.activeSolutions"
      [ctx]="this.ctx"
      [targetKind]="this.closeTargetKind"
      [aggregateState]="this.closeAllState"
      [expanded]="this.closeAllExpanded"
      (expandedChange)="this.onCloseAllExpandedChange($event)"
      (previewAll)="this.onPreviewAllToggle()"
      (applyAll)="this.onApplyAllToggle()"
    ></ets-hg-copilot-close-all-card>
  </div>

  </div>
  </dx-scroll-view>

</div>
